import { SolverHolder } from '../types';
import { doWith } from '../utils';
import { VPSolverType1, VPSolverType2 } from './vp-solver';

export const avaliableSolvers: Array<SolverHolder<any>> = [
  { id: 0, label: '2VP + Reference Height', instance: (options) => doWith(new VPSolverType1(options) as any, (s) => s.prepare()) },
  { id: 1, label: '2VP + Reference Depth', instance: (options) => doWith(new VPSolverType2(options) as any, (s) => s.prepare()) },
];
